import {getDateString} from "../../utils/Utils";

let TableWeekController = (props) => {
    /**
     * props.action: PREVIOUS or NEXT
     * props.startDate: start Date
     * props.endDate: end Date
     * props.isAdmin: boolean
     * props.onChangeDate: fn
     */
    let onClickControll = (_) => {
        let nextDate = new Date(props.startDate);
        let dateGap = props.action ? 7 : -7;
        nextDate.setDate(nextDate.getDate() + dateGap);

        let nextEndDate = new Date(nextDate);
        nextEndDate.setDate(nextEndDate.getDate() + 6);

        let compareDate = new Date();
        compareDate.setMonth(compareDate.getMonth() + 1);

        if (getDateString(nextDate) > getDateString(compareDate) && !props.isAdmin)
            return;

        props.onChangeDate(nextDate, nextEndDate, props.action ? nextDate : nextEndDate);
    }

    return (<div className="table-week-controller-container" onClick={onClickControll.bind(this)}>
        <p className="table-week-controller">{props.action ? ">" : "<"}</p>
    </div>)
}
export default TableWeekController;